import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useBuInstanceLabel } from "@/hooks/use-bu-instance-label";
import { useCreateBuInstance } from "@/hooks/use-bu-instances";
import { BuInstanceForm } from "./BuInstanceForm";

interface BuInstanceCreateDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/** Create dialog — wraps the shared `BuInstanceForm`. Triggered from the table toolbar. */
export function BuInstanceCreateDialog({ open, onOpenChange }: BuInstanceCreateDialogProps) {
  const { label } = useBuInstanceLabel();
  const createBuInstance = useCreateBuInstance();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>New {label}</DialogTitle>
          <DialogDescription>
            Add a Coach Manager connection for another Business Unit.
          </DialogDescription>
        </DialogHeader>
        <BuInstanceForm
          submitLabel="Create"
          isSaving={createBuInstance.isPending}
          onCancel={() => onOpenChange(false)}
          onSubmit={(result) =>
            createBuInstance.mutate(
              { ...result, password: result.password ?? "" },
              { onSuccess: () => onOpenChange(false) },
            )
          }
        />
      </DialogContent>
    </Dialog>
  );
}
